import { render, staticRenderFns } from "./AppButtonSmRemove.vue?vue&type=template&id=f38a828c&scoped=true&"
import script from "./AppButtonSmRemove.vue?vue&type=script&lang=js&"
export * from "./AppButtonSmRemove.vue?vue&type=script&lang=js&"
import style0 from "./AppButtonSmRemove.vue?vue&type=style&index=0&id=f38a828c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38a828c",
  null
  
)

export default component.exports